import { DocumentStatus, OtherDocumentTypes } from '@/types/document';
import { LoanAgreementStatus, LoanAgreementType } from '@/types/loan_agreements';
import { TransactionStatus } from '@/types/bank';

export const DOCUMENT_FILTER_TYPE_MATCHED = 'matched';
export const DOCUMENT_FILTER_TYPE_UNMATCHED = 'unmatched';

export const FILTER_GROUP_DOCUMENT_STATUS = 'status';
export const FILTER_GROUP_DOCUMENT_MATCHING = 'matching';
export const FILTER_GROUP_DOCUMENT_SEARCH = 'search';

export const DOCUMENT_STATUS_FILTERS = [...Object.values(DocumentStatus)];
export const DOCUMENT_MATCHING_FILTERS = [
  DOCUMENT_FILTER_TYPE_MATCHED,
  DOCUMENT_FILTER_TYPE_UNMATCHED
];
export const TRANSACTION_STATUS_FILTERS = [...Object.values(TransactionStatus)];

export const OTHER_DOCUMENT_TYPE_FILTERS = [...Object.values(OtherDocumentTypes)];

export const FILTER_GROUP_AGREEMENT_TYPE = 'type';
export const FILTER_GROUP_AGREEMENT_STATUS = 'status';
export const AGREEMENT_TYPE_FILTERS = [...Object.values(LoanAgreementType)];
export const AGREEMENT_STATUS_FILTERS = [...Object.values(LoanAgreementStatus)];
